"use client";

/*
 * Update the SDK with lifecycle events, requires window (client)
 */

import { usePathname } from "next/navigation";
import React, { useRef } from "react";
import useContentVisible from "./use-content-visible";
import useOnLoadPublisher from "./use-onload-publisher";
import useResizePublisher from "./use-resize-publisher";
import { useTabBarRouteSyncPublisher } from "./use-tabbar-visibility-publisher";

interface FeltEmbeddedComponentProps {
  children: React.ReactNode;
  id?: string;
}

export const FeltEmbeddedComponent: React.FC<FeltEmbeddedComponentProps> =
  React.memo(({ children, id = usePathname() }) => {
    const ref = useRef<HTMLDivElement>(null);

    useOnLoadPublisher(id);
    useResizePublisher(id, ref);
    useContentVisible(ref);
    useTabBarRouteSyncPublisher();

    return (
      <div ref={ref} data-name="felt-content">
        {children}
      </div>
    );
  });

export default FeltEmbeddedComponent;
